import React, { Component } from "react";
import Chart from "react-apexcharts";

class Charts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      options: {
        grid: {
          show: true,  
          xaxis: {
            lines: {
              show: false
             }
           },  
          yaxis: {
            lines: { 
              show: true
             }
           },   
        },
        stroke: {
          colors: ["transparent"],
          width: 3,
        },
        plotOptions: {
          bar: {
            borderRadius: 3,
          },
        },

        colors: ["#0095FF", "#FFC0CB"],
        chart: {
          id: "basic-bar",
          toolbar: {
            show: false,
          },
        },

        xaxis: {
          categories: [2016, 2017, 2018, 2019, 2020, 2021, 2022],
        },
        dataLabels: {
          enabled: false,
        },

        yaxis: {
          labels: {
            formatter: function (value) {
              return value + "k";
            },
          },
        },

        /*  yaxis: {
          categories: [0, "5k", "10k", "15k", "20k", "25k", "30k"]
        } */
      },
      series: [
        {
          name: "Male",
          data: [30, 40, 15, 55, 51, 60, 63],
        },
        {
          name: "Female",
          data: [20, 20, 70, 18, 49, 50, 47],
        },
      ],
    };
  }

  render() {
    return (
      <div className="app">
        <div className="row">
          <div className="mixed-chart">
            <Chart
              options={this.state.options}
              series={this.state.series}
              type="bar"
              // width="100%"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Charts;
